var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.201,
    height: 20.361,
    viewBox: "0 0 19.201 20.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079",
    transform: "translate(-19.134 -28.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M58.305,235.107l-1.774-5.155a.182.182,0,0,0-.356.012l-.553,1.928a.2.2,0,0,1-.18.151H51.615a.224.224,0,0,0-.156.346,36.185,36.185,0,0,0,5.5,6.492c.725.718,1.5,1.482,2.306,2.306l.241.246a.17.17,0,0,0,.25,0l.242-.246c.81-.824,1.581-1.588,2.306-2.306a36.19,36.19,0,0,0,5.5-6.492.224.224,0,0,0-.156-.346H60.094a.189.189,0,0,0-.17.122l-1.273,2.959A.18.18,0,0,1,58.305,235.107Z",
    transform: "translate(-30.898 -192.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M33.274,28.5A5.105,5.105,0,0,0,28.9,31.541a.182.182,0,0,1-.329,0A5.073,5.073,0,0,0,24.233,28.5h-.038c-2.677.024-4.918,2.57-5.054,5.8a7.28,7.28,0,0,0,.444,2.853.192.192,0,0,0,.177.131h3.929a.2.2,0,0,0,.182-.146l1.274-4.26a.186.186,0,0,1,.36-.012l2,5.582a.184.184,0,0,0,.349.016l.476-1.062a.191.191,0,0,1,.171-.118h9.2a.192.192,0,0,0,.177-.131,7.276,7.276,0,0,0,.444-2.853C38.192,31.07,35.951,28.524,33.274,28.5Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.87c8ddd8cd41fe51d0f3df126a4b4e2a.svg";
export { ForwardRef as ReactComponent };